import { useEffect } from "react";
import { Text } from "@chakra-ui/react";
import { ShoppingCart } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useMyCart } from "../../contexts/MyCartContext";
import FloatingToast from "./FloatingToast";

const GREEN = "#16a34a";
// Must match TOAST_DURATION in useDraftBookingNotifications
const BAR_DURATION = 15;

export default function AddOnToast() {
  const { toast } = useMyCart();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === "/my-cart" && toast.visible) {
      toast.dismiss();
    }
  }, [pathname, toast]);

  return (
    <FloatingToast
      visible={toast.visible && pathname !== "/my-cart"}
      toastKey="addon-toast"
      accentColor={GREEN}
      icon={<ShoppingCart size={15} color="white" />}
      title="Add-on services added!"
      description={<Text>Tap to review and pay</Text>}
      zIndex={9999}
      onClick={() => {
        toast.dismiss();
        navigate("/my-cart");
      }}
      onDismiss={toast.dismiss}
      progressDurationSeconds={BAR_DURATION}
      progressKey="addon-toast-bar"
    />
  );
}
